import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

window.addEventListener("vite:preloadError", () => { window.location.reload(); });
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initializeSentry, isSentryEnabled } from "./lib/sentry";

initializeSentry();

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

createRoot(document.getElementById("root")!).render(
  isSentryEnabled() ? (
  <Sentry.ErrorBoundary
    fallback={({ eventId, resetError }) => (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
        <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
        <p className="mt-3 max-w-md text-sm text-muted-foreground">
          The error has been reported. Refresh the page or try again.
        </p>
        {eventId ? (
          <p className="mt-2 text-xs text-muted-foreground">Event ID: {eventId}</p>
        ) : null}
        <button
          type="button"
          onClick={resetError}
          className="mt-6 rounded-md bg-foreground px-4 py-2 text-sm font-medium text-background transition-opacity hover:opacity-90"
        >
          Try again
        </button>
      </div>
    )}
  >
    {app}
  </Sentry.ErrorBoundary>
  ) : (
    app
  )
);
